import React from 'react'
import PropTypes from 'prop-types'
import {
  isDigitalWellBeingUrl,
  isK5Url,
  isK5Dashboard,
  isMiddleSchoolUrl,
  isMiddleSchoolDashboard,
} from 'utils/productHelpers'
import { isTier2Url } from 'utils/urlHelpers'
import CoursePreviewBanner from './component'

export function extractLessonsLink(text) {
  return text.match(/^(.*?)<0>(.*?)<\/0>(.*?)$/)
}

// Helper function to extract class parameter from URL
const getClassIdFromUrl = () => {
  const queryParams =
    window.location.search
      ?.replace(/^\?/, '')
      .split('&')
      .map(kv => kv.split('='))
      .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {}) ?? {}
  return queryParams.class
}

const CoursePreviewBannerContainer = ({
  customTopMargin,
  isTraining = false,
  lessonsLink,
}) => {
  // Determine the correct link based on training state and lesson route detection
  const getCorrectLink = () => {
    const isTier2OrDigitalWellBeingUrl = isTier2Url() || isDigitalWellBeingUrl()

    // Handle training state
    if (isTraining) {
      // Check if it's elementary or middle school context
      const isElementary = isK5Url() || isK5Dashboard()
      const isMiddleSchool = isMiddleSchoolUrl() || isMiddleSchoolDashboard()

      if (isElementary) {
        return '/dashboard/grades-k-5'
      } else if (isMiddleSchool) {
        return '/dashboard/grades-6-8'
      }

      // Default fallback (shouldn't happen but safety net)
      return lessonsLink || '/dashboard/grades-6-8'
    }

    // Handle specialized lesson preview state
    if (isTier2OrDigitalWellBeingUrl) {
      // For specialized lessons, we want to link to the lessons page with class parameter
      // Extract the program from the current URL
      const pathParts = window.location.pathname.split('/')
      const programIndex = pathParts.findIndex(part => part === 'product') + 1
      const program = pathParts[programIndex]
      const classId = getClassIdFromUrl()

      if (program) {
        const classParam = classId ? `?class=${classId}` : ''
        return `/product/${program}/lessons${classParam}`
      }

      // Fallback to general lessons page
      return lessonsLink || '/lessons'
    }

    // Default case - return the original lessonsLink
    return lessonsLink
  }

  return (
    <CoursePreviewBanner
      customTopMargin={customTopMargin}
      extractLessonsLink={extractLessonsLink}
      isTraining={isTraining}
      lessonsLink={getCorrectLink()}
    />
  )
}

CoursePreviewBannerContainer.propTypes = {
  customTopMargin: PropTypes.string,
  isTraining: PropTypes.bool,
  lessonsLink: PropTypes.string,
}

export default CoursePreviewBannerContainer
